import { useContext } from "react";
import { ConferenceContext } from "../../components/ConferenceProvider/ConferenceProvider";

export const useConferenceContext = () => {
	const context = useContext(ConferenceContext);
	if (!context) {
		throw new Error("useConferenceContext must be used within a ConferenceProvider");
	}
	return context;
};
